import type { FC, ReactElement } from "react"

import { ETypographyAlignment, ETypographySize } from "@/3514/components"
import { type TScreenBreakpoints, useScreenBreakpoints } from "@/3514/hooks"
import { type IUseTranslation, useTranslation } from "@/hooks"

import {
    type TDiagnosticSummarySuspenseQuery as TSuspenseQuery,
    useDiagnosticSummarySuspenseQuery as useSuspenseQuery
} from "./diagnostic-summary.api.queries.hook"
import type { TDiagnosticSummaryEntityProps as TProps } from "./diagnostic-summary.ui.types"
import uiUtils from "./diagnostic-summary.ui.utils"
import View from "./diagnostic-summary.view"

const DiagnosticSummaryCoachContainer: FC<TProps> = ({
    participantId,
    wrapperClassName = String("")
}: TProps): ReactElement => {
    const { data: diagnosticData }: TSuspenseQuery = useSuspenseQuery({ participantId })

    const { t }: IUseTranslation = useTranslation()

    const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

    const entityYGap: number = breakpoints.xs || breakpoints.sm ? 15 : 30

    return (
        <View
            data={diagnosticData}
            titleText={t("entities.diagnosticSummary.coach.title")}
            titleAlignment={ETypographyAlignment.Left}
            titleSize={ETypographySize.Heading2}
            freeResponsesMapper={uiUtils.freeResponsesMapper}
            likertQuestionsMapper={uiUtils.likertQuestionsMapper}
            entityYGap={entityYGap}
            wrapperClassName={wrapperClassName}
        />
    )
}

DiagnosticSummaryCoachContainer.displayName = "DiagnosticSummaryCoachContainer"

export default DiagnosticSummaryCoachContainer
